import { useRef, useState } from 'react';

export default function ModalAsignacionesTarjeta({ tarjeta, asignaciones, onClose, onDescargar, onSubirFirmada }) {
  const fileRef = useRef();
  const [asignSeleccionada, setAsignSeleccionada] = useState(null);
  if (!tarjeta) return null;
  const formatFecha = (f) => {
    if (!f) return '—';
    if (typeof f === 'string' && f.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [y, m, d] = f.split('-');
      return `${d}-${m}-${y}`;
    }
    const d = new Date(f);
    return `${String(d.getUTCDate()).padStart(2, '0')}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${d.getUTCFullYear()}`;
  };

  const colores = { 'Pendiente': '#007bff', 'Firmada': '#28a745', 'Cancelada': '#dc3545' };

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}
        style={{ width: 600, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <h3 style={{ margin: 0 }}>Asignaciones — **** {tarjeta.numero_tarjeta?.slice(-4)}</h3>
        </div>

        <div style={{ overflowY: 'auto', flex: 1, marginTop: 16 }}>
          {!asignaciones || asignaciones.length === 0 ? (
            <p style={{ color: '#888' }}>Sin asignaciones registradas</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead style={{ position: 'sticky', top: 0 }}>
                <tr style={{ background: '#1e6378', color: 'white' }}>
                  <th style={{ padding: '8px', textAlign: 'left' }}>Usuario</th>
                  <th style={{ padding: '8px', textAlign: 'left' }}>F. Préstamo</th>
                  <th style={{ padding: '8px', textAlign: 'left' }}>F. Regreso</th>
                  <th style={{ padding: '8px', textAlign: 'left' }}>Estado</th>
                  <th style={{ padding: '8px', textAlign: 'left' }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {asignaciones.map((a, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px' }}>{a.usuario_nombre}</td>
                    <td style={{ padding: '8px' }}>{formatFecha(a.fecha_prestamo)}</td>
                    <td style={{ padding: '8px' }}>{formatFecha(a.fecha_regreso)}</td>
                    <td style={{ padding: '8px' }}>
                      <span style={{
                        padding: '3px 8px', borderRadius: 4, fontSize: 11,
                        color: 'white', background: colores[a.estado] ?? '#6c757d'
                      }}>
                        {a.estado}
                      </span>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <button className="btn-edit" onClick={() => onDescargar(a)}>Descargar</button>
                      {a.estado === 'Pendiente' && (
                        <button className="btn-edit" style={{ background: '#28a745', color: 'white' }}
                          onClick={() => { setAsignSeleccionada(a); fileRef.current.click(); }}>
                          Subir firmada
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <input ref={fileRef} type="file" accept="application/pdf" style={{ display: 'none' }}
          onChange={(e) => {
            const archivo = e.target.files[0];
            if (archivo && asignSeleccionada) onSubirFirmada(asignSeleccionada, archivo);
            e.target.value = '';
          }} />

        <div style={{ textAlign: 'right', marginTop: 16, flexShrink: 0 }}>
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}